import f from "../../funcs";

import Api from "./Api";


let DesktopApi = Api.extend("DesktopApi", {
    _entity: "desktop"
});

DesktopApi.prototype.load = function(callback) {
    this._request({
        method: "load"
    }, function(err, result) {
        if ( err || !result.desktop ) {
            result.desktop = { icons: [] };
        }

        callback(err, result.desktop);
    });
};

DesktopApi.prototype.save = function(data, callback) {
    if ( !f.isFunction(callback) ) {
        callback = function() {};
    }

    this._request({
        method: "save",
        data
    }, callback);
};

export default DesktopApi;
